"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomersClient = void 0;
const client_1 = require("@leid/client");
class CustomersClient extends client_1.ClientBase {
    // ------ CUSTOMERS ------
    async getCustomers(filter) {
        try {
            const response = await this.httpClient.get('/customers', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustomers error on a call', filter);
        }
    }
    async getCustomer(id) {
        try {
            const response = await this.httpClient.get(`/customers/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustomer error on a call', id);
        }
    }
    async createCustomer(request) {
        try {
            const response = await this.httpClient.post('/customers', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createCustomer error on a call', request);
        }
    }
    async updateCustomer(id, request) {
        try {
            const response = await this.httpClient.put(`/customers/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateCustomer error on a call', request);
        }
    }
    async completeCustomer(id, request) {
        try {
            const response = await this.httpClient.post(`/customers/${id}/complete`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'completeCustomer error on a call', request);
        }
    }
    async cleanupCustomer(id) {
        try {
            const response = await this.httpClient.post(`/customers/${id}/cleanup`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'cleanupCustomer error on a call', id);
        }
    }
    async addToNewsletter(email) {
        try {
            const response = await this.httpClient.post(`/customers/newsletters/${email}/subscription`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'addToNewsletter error on a call');
        }
    }
    async sendCustomerRegistrationSms(phoneNumber) {
        try {
            const response = await this.httpClient.post(`/customers/registration/${phoneNumber}/sms`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendCustomerRegistrationSms error on a call');
        }
    }
    async processNewsletterSubscriptionUpdate(request) {
        try {
            const response = await this.httpClient.post('/customers/newsletters/klaviyo/subscription', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'processNewsletterSubscriptionUpdate error on a call');
        }
    }
    // ------ VIPPS QUICK REGISTRATION ------
    async inviteCustomerFromVipps(request) {
        try {
            const response = await this.httpClient.post('/customers/invites/vipps', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'inviteCustomerFromVipps error on a call');
        }
    }
    async processAcceptedInvitationFromVipps(request) {
        try {
            const response = await this.httpClient.post('/customers/invites/vipps/accepted', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'processAcceptedInvitationFromVipps error on a call');
        }
    }
    // ------ CREDITS ------
    async getCredits(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/credits', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCredits error on a call', filter);
        }
    }
    async getCredit(id) {
        try {
            const response = await this.httpClient.get(`/credits/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCredit error on a call', id);
        }
    }
    async createCredit(request) {
        try {
            const response = await this.httpClient.post('/credits', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createCredit error on a call', request);
        }
    }
    async updateCredit(id, request) {
        try {
            const response = await this.httpClient.put(`/credits/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateCredit error on a call', request);
        }
    }
    async refundCredits(request) {
        try {
            const response = await this.httpClient.post('/credits/refund', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'refundCredits error on a call', request);
        }
    }
    // LEGACY getBalance function, TODO: REMOVE IN FUTURE:
    async getBalance(customerId) {
        try {
            const response = await this.httpClient.get(`/credits/${customerId}/balance`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustomerBalance error on a call', customerId);
        }
    }
    async getCustomerBalance(customerId) {
        try {
            const response = await this.httpClient.get(`/credits/customers/${customerId}/balance`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustomerBalance error on a call', customerId);
        }
    }
    async getOrganizationBalance(organizationId) {
        try {
            const response = await this.httpClient.get(`/credits/organizations/${organizationId}/balance`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrganizationBalance error on a call', organizationId);
        }
    }
    // LEGACY, remove in future
    async useCredits(customerId, amount, data) {
        try {
            const response = await this.httpClient.post(`/credits/${customerId}/use/${amount}`, data);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'useCredits error on a call', customerId);
        }
    }
    async useCustomerCredits(customerId, amount, data) {
        try {
            const response = await this.httpClient.post(`/credits/customers/${customerId}/use/${amount}`, data);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'useCredits error on a call', customerId);
        }
    }
    async useOrganizationCredits(organizationId, amount, data) {
        try {
            const response = await this.httpClient.post(`/credits/organizations/${organizationId}/use/${amount}`, data);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'useOrganizationCredits error on a call', organizationId);
        }
    }
    // ------ RESERVATIONS ------
    async getReservations(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/reservations', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getReservations error on a call', filter);
        }
    }
    async getReservation(id) {
        try {
            const response = await this.httpClient.get(`/reservations/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getReservation error on a call', id);
        }
    }
    async createReservation(request) {
        try {
            const response = await this.httpClient.post('/reservations', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createReservation error on a call', request);
        }
    }
    async unreserveReservation(id) {
        try {
            const response = await this.httpClient.put(`/reservations/${id}/unreserve`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'unreserveReservation error on a call', id);
        }
    }
    async finishReservation(orderId) {
        try {
            const response = await this.httpClient.post(`/reservations/orders/${orderId}/finish`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'finishReservation error on a call', orderId);
        }
    }
    async refundReservation(id, request) {
        try {
            const response = await this.httpClient.put(`/reservations/${id}/refund`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'refundReservation error on a call', id);
        }
    }
    // ------ DEDUCTION LOGS ------
    async getDeductionLogs(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/deduction-logs', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDeductionLogs error on a call', filter);
        }
    }
    async getDeductionLog(id) {
        try {
            const response = await this.httpClient.get(`/deduction-logs/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDeductionLog error on a call', id);
        }
    }
    // ------ CONTACT FORM ------
    async sendContactForm(request) {
        try {
            const response = await this.httpClient.post('/contact-forms', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendContactForm error on a call', request);
        }
    }
    // ------ CUSTOMER LIFECYCLE ------
    async executeCustomerLifecycleAction(customerId, reminderType) {
        try {
            const response = await this.httpClient.post(`/lifecycle/${customerId}/action/${reminderType}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'executeCustomerLifecycleAction error on a call', customerId, reminderType);
        }
    }
    /* CUSTOMER NOTES */
    async getCustomerNotes(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/customer-notes', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustomerNotes error on a call', filter, sortingData);
        }
    }
    async getCustomerNote(id) {
        try {
            const response = await this.httpClient.get(`/customer-notes/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustomerNote error on a call', id);
        }
    }
    async createCustomerNote(customerNote) {
        try {
            const response = await this.httpClient.post('/customer-notes', customerNote);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createCustomerNote error on a call', customerNote);
        }
    }
    async deleteCustomerNote(id) {
        try {
            const response = await this.httpClient.delete(`/customer-notes/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteCustomerNote error on a call', id);
        }
    }
    // ------ ORGANIZATIONS ------
    async getOrganizations(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/organizations', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrganizations error on a call', filter, sortingData);
        }
    }
    async getOrganization(id) {
        try {
            const response = await this.httpClient.get(`/organizations/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getOrganization error on a call', id);
        }
    }
    async createOrganization(request) {
        try {
            const response = await this.httpClient.post('/organizations', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createOrganization error on a call', request);
        }
    }
    async updateOrganization(id, updateOrganizationRequest) {
        try {
            const response = await this.httpClient.put(`/organizations/${id}`, updateOrganizationRequest);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateOrganization error on a call', id, updateOrganizationRequest);
        }
    }
    async refreshOrganizationInfo(id) {
        try {
            const response = await this.httpClient.put(`/organizations/${id}/refresh`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'refreshOrganizationInfo error on a call', id);
        }
    }
    async getCustomerOrganizationsFromOrganization(organizationId) {
        try {
            const response = await this.httpClient.get(`/organizations/${organizationId}/customer-organizations`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustomerOrganizationsFromOrganization error on a call', organizationId);
        }
    }
    async addCustomerToOrganization(customerOrganizationAddRequest) {
        try {
            const response = await this.httpClient.post('/organizations/add-customer', customerOrganizationAddRequest);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'addCustomerToOrganization error on a call', customerOrganizationAddRequest);
        }
    }
    async removeCustomerFromOrganization(organizationId, customerId) {
        try {
            const response = await this.httpClient.delete(`/organizations/${organizationId}/remove-customer/${customerId}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'removeCustomerFromOrganization error on a call', organizationId, customerId);
        }
    }
    async getSpecificCustomerOrganization(organizationId, customerId) {
        try {
            const response = await this.httpClient.get(`/organizations/${organizationId}/customer-organizations/${customerId}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSpecificCustomerOrganization error on a call', organizationId, customerId);
        }
    }
    async updateCustomerOrganization(id, customerOrganization) {
        try {
            const response = await this.httpClient.put(`/organizations/customer-organizations/${id}`, customerOrganization);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateCustomerOrganization error on a call', id, customerOrganization);
        }
    }
    async customerRequestToJoinOrganization(request) {
        try {
            const response = await this.httpClient.post('/organizations/customer-organizations/request-to-join', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'customerRequestToJoinOrganization error on a call', request);
        }
    }
    async decryptCustomerOrganizationData(request) {
        try {
            const response = await this.httpClient.post('/organizations/customer-organizations/decrypt', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'decryptCustomerOrganizationData error on a call', request);
        }
    }
    async removeCustomer(id) {
        try {
            const response = await this.httpClient.put(`/customers/${id}/remove`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'removeCustomer error on a call', id);
        }
    }
    // ------ SUBSCRIPTION REWARDS ------
    async getSubscriptionRewards(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/subscription-rewards', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSubscriptionRewards error on a call', filter, sortingData);
        }
    }
    async getSubscriptionReward(id) {
        try {
            const response = await this.httpClient.get(`/subscription-rewards/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getCustgetSubscriptionRewardomerNote error on a call', id);
        }
    }
    async createSubscriptionReward(request) {
        try {
            const response = await this.httpClient.post('/subscription-rewards', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createSubscriptionReward error on a call', request);
        }
    }
    async updateSubscriptionReward(id, request) {
        try {
            const response = await this.httpClient.put(`/subscription-rewards/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateSubscriptionReward error on a call', request);
        }
    }
}
exports.CustomersClient = CustomersClient;
